export const EMPLOYEE_CPR_TOGGLE = 'EnableEmployeeCpr';

export const EMPLOYEE_CPR_ERROR_TEXT = 'CPR-nummeret skal bestå af 10 cifre.';
